<template>
   <div>
    <template v-for="menu in this.menuData">
     <el-submenu class="myClass" :key="menu.index" ref="submenuRef" :name="menu.name" v-show="menu.isShow == 1"  :index="menu.index" v-if="menu.children">
       <template slot="title">
         <span slot="title" class="names">{{menu.name}}</span>
       </template>
       <menu-tree  :menuData="menu.children"></menu-tree>
     </el-submenu>





     <el-menu-item :key="menu.index"   :name="menu.name" v-show="menu.isShow == 1"  :index="menu.index" v-else>
       <span slot="title" class="names">{{menu.name}}</span>
     </el-menu-item>

    </template>
   </div>
</template>

<script>
// import {getInformation} from "../api";

export default {
  props: ['menuData'],
  name: 'MenuTree',
  data(){
    return{
      statusData:{},
    }
  },

  mounted() {
// this.getInformations()
//     console.log(this.menuData)
  },


  methods:{

    // getInformations(){
    //
    //   let params = {
    //     certNO:'34290119920820451T',
    //     certTypeCode:'1',
    //   }
    //
    //   getInformation(params).then(res=>{
    //
    //     if (res.errorCode == 200){
    //       this.statusData = res.data
    //
    //     }
    //
    //   })
    //
    // }
  }
}
</script>
<style scoped lang="less">

.names{
  font-size: 0.875rem;
}

</style>

<style lang="less" >
  .myClass /deep/ .el-submenu__title {
    background-color: #f00 !important; /* 红色背景 */
  }


</style>



// WEBPACK FOOTER //
// src/landmark-user/components/MentTree.vue